
export default console